// action - state management
import * as actionTypes from './actions';

export const initialState = {
  initial: true,
  isLoading: false,
  batchResults: [],
  errors: [],
  currentIndex: 0,
  totalFiles: 0,
  completedCount: 0,
  progress: 0,
  error: null
};

// ===========================|| BATCH OCR REDUCER ||=========================== //

const batchOCRReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.BATCH_OCR_START:
      return {
        ...state,
        initial: false,
        isLoading: true,
        batchResults: [],
        errors: [],
        currentIndex: 0,
        totalFiles: action.totalFiles || 0,
        completedCount: 0,
        progress: 0,
        error: null
      };
    case actionTypes.BATCH_OCR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        batchResults: action.data || [],
        errors: action.errors || [],
        completedCount: action.completedCount || 0,
        progress: action.progress || 100,
        error: null,
        initial: false
      };
    case actionTypes.BATCH_OCR_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        batchResults: [],
        errors: [],
        initial: false
      };
    case actionTypes.BATCH_OCR_UPDATE_PROGRESS:
      return {
        ...state,
        currentIndex: action.currentIndex || 0,
        completedCount: action.completedCount || 0,
        progress: action.progress || 0,
        batchResults: action.batchResults || state.batchResults
      };
    case actionTypes.BATCH_OCR_CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default batchOCRReducer;
